<template>
  <div class="text-center" v-if="loading">
    <span>Loading</span><br>
    <CSpinner grow=true color="danger"></CSpinner>
  </div>
  <CCard v-else>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Promotions
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'BkashPromotionCreate'}">
          <button class="btn btn-success">Create New Prizes for promotion</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="promotions" :columns="columns" :options="options">
        <template slot="published_status" slot-scope="props">
          <div>
<!--            <span v-if="props.row.published_status" class="badge badge-success badge-sm">published</span>-->
<!--            <span v-else class="badge badge-warning badge-sm">unpublished</span>-->
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'BkashPromotionEdit',  params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="deletePrize(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "BkashPromotions",
  data() {
    return {
      loading : false,
      promotions: [],
      columns: ["id", "title", "body", "action"],
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getPromotions();
  },
  methods: {
    getPromotions() {
      this.$axios
          .get(`${ADMIN_URL}/bkash-prizes`)
          .then((response) => {
            console.log("topics, response === ", response.data);
            this.promotions = response.data.data;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    deletePrize(id)
    {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };
      let formData = new FormData();
      formData.append("prize_id", id);

      this.$axios
          .post(`${ADMIN_URL}/prize-delete`, formData, config)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getPromotions()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>

